<template>
    <div :class="`send-btn-container-${align}`" >
        <button v-if="!isSpecial" id="container" class="send-btn" @click="sendForm">{{ fieldLabel }}</button>
        <!--        betnano için özel tasarım-->
        <div class="nano-btn" v-else @click="sendForm">
            <img src="../../../SpecialForm/assets/nanosendbtn.png" class="nano-img">
            <div class="label-overlay">{{ fieldLabel }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormSendBtn",
    props: {
        fieldLabel: {
            type: String,
            default: "Send",
        },
        align: {
            type: String,
            default: "top",
        },
        formId: {
            type: String,
            required: true,
        },
        order: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            isSpecial: false,
        };
    },
    methods: {
        sendForm() {
            this.$emit("submit");
        }
    },
    mounted() {
        const special = this.$route.query.special;
        if (special === "true") {
            this.isSpecial = true;
        }
    }
};
</script>

<style lang="scss" scoped>
.nano-btn {
    position: relative;
    display: inline-block;
    width: 200px;
    height: 200px;
    text-align: center;
    cursor: pointer;
}

.nano-img {
    width: 100%;
    height: 80px;
    display: block;
}

.label-overlay {
    position: absolute;
    top: 20%;
    left: 45%;
    transform: translate(-50%, -50%);
    color: #fbb03a;
    font-weight: bold;
    text-align: center;
    font-family: sans-serif;
}

.send-btn-container-left {
    display: flex;
    padding: 20px;
}

.send-btn-container-right {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
}

.send-btn {
    margin: 10px;
    background: #2c3e50;
    color: #fff;
    padding: 10px 20px;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    outline: none;

    &:hover {
        background: #1a252f;
    }
}
</style>